<div id='jitsi-meet-conf-container' [hidden]="errorMsg || loading"></div>


<div class="p-3 h-100 d-flex align-items-center justify-content-center" *ngIf="errorMsg || loading">
  <div *ngIf="!loading">
    <h4>{{errorMsg}}</h4>

    <div class="text-center mt-5" *ngIf="canReload">
      <button class="btn btn-primary" (click)="extendMeeting()">Reload</button>
    </div>

  </div>
  <div class="dataLoading" *ngIf="loading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>
</div>
